import { useNavigate } from 'react-router-dom';
import messageSquareIcon from '../../../assets/icons/messages-square.svg';
import { usePatientMetadata } from '../../../providers/PatientMetadataProvider';
import type { PatientListItemType } from '../../../providers/patient/PatientsListProvider';
import { getNameClickRoute } from '../../../utils/actionRoutes';
import { CHAT_QUERY_OPEN, CHAT_QUERY_PARAM } from '../../../utils/constants';

interface ChatCellProps {
    patient: PatientListItemType;
    onChatClick?: (patientId: string) => void;
}

/** Opens the chat slide-over (onChatClick) or falls back to navigating straight to it. */
export function ChatCell({ patient, onChatClick }: ChatCellProps) {
    const navigate = useNavigate();
    const { hasUnreadMessages } = usePatientMetadata();
    const hasUnread = hasUnreadMessages(patient.id);

    return (
        <button
            className="relative mx-auto flex items-center justify-center w-8 h-8 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors"
            onClick={() => {
                if (onChatClick && patient.id) {
                    onChatClick(patient.id);
                } else if (patient.id) {
                    const route = getNameClickRoute(patient.requiredAction ?? null, patient.id);
                    navigate(`${route}?${CHAT_QUERY_PARAM}=${CHAT_QUERY_OPEN}`);
                }
            }}
            aria-label="Open chat"
        >
            <img src={messageSquareIcon} alt="Chat" className="w-4 h-4" />
            {hasUnread && (
                <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-yellow-400 rounded-full border-2 border-white" />
            )}
        </button>
    );
}
